<template>
    <div class="itemgroup-detail">
        <v-container>
            <v-card>
                <v-card-title style="background-color: rgb(33, 57, 141); color: white;">Product types</v-card-title>
                <v-card-text>
                    <v-container>
                        <v-form v-model="valid">
                            <v-text-field
                                    v-model="title"
                                    :rules="titleRules"
                                    :counter="255"
                                    v-bind:label="$t('productType.title')"
                                    required
                            ></v-text-field>
                            <v-btn color="primary" @click="saveAction">
                                {{$t('message.save')}}
                            </v-btn>
                        </v-form>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-container>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';

    export default {
        mounted() {
            if(this.$route.params.id != null) {
                this.id = this.$route.params.id;
                this.$store.dispatch('productTypes/loadById', {id: this.id}).then(() => {
                    const widget = this.$store.getters['productTypes/byId']({id: this.id});
                    this.title = widget.attributes.title;
                });
            } else {

            }
        },
        methods: {
            ...mapActions({
                delete: 'productTypes/delete',
            }),

            saveAction: function() {
                if(this.$route.params.id != null) {
                    const widget = this.$store.getters['productTypes/byId']({ id: this.id });
                    widget.attributes.title = this.title;
                    this.$store.dispatch('productTypes/update', widget).then(() => {
                         this.$router.back();
                    });
                } else {
                    const recordData = {
                        attributes: {
                            title: this.title,
                        },
                    };
                    this.$store.dispatch('productTypes/create', recordData).then(() => {
                         this.$router.back();
                    });
                }
            }

        },
        computed: {
            ...mapGetters({
                loading: "productTypes/isLoading",
                error: "productTypes/isError",
            }),
        },
        data: () => ({
            valid: false,
            id: null,
            title: '',
            titleRules: [
                v => !!v || 'Name is required',
                v => v.length <= 255 || 'Name must be less than 255 characters'
            ]
        })
    }
</script>
